/* eslint-disable react/no-unused-prop-types */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { defaultReducers, combineReducers } from './reducers';

export const GridContext = React.createContext();

export function GridContextProvider(props) {
  const {
    middlewares, reducers,
  } = props;


  const allReducers = [...defaultReducers, ...reducers];

  const { reducer, getInitialState } = combineReducers(allReducers);

  const [state, _dispatch] = React.useReducer(reducer, getInitialState(props));

  const dispatch = useCallback((action) => {
    middlewares.forEach((middleware) => {
      middleware(action, state);
    });
    _dispatch(action);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [middlewares]);

  const context = {
    state,
    dispatch,
  };

  return (
    <GridContext.Provider value={context}>
      {props.children}
    </GridContext.Provider>
  );
}


GridContextProvider.propTypes = {
  middlewares: PropTypes.arrayOf(PropTypes.func),
  allColumns: PropTypes.arrayOf(PropTypes.shape({})),
  selectedColumns: PropTypes.arrayOf(PropTypes.shape({})),
  sortedColumn: PropTypes.shape({}),
  segmentation: PropTypes.shape({}),
  pagination: PropTypes.shape({}),
  filter: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
  ]),
  children: PropTypes.node.isRequired,
  reducers: PropTypes.arrayOf(PropTypes.shape({})),
};

GridContextProvider.defaultProps = {
  middlewares: [],
  allColumns: [],
  selectedColumns: [],
  sortedColumn: {},
  segmentation: {},
  filter: [],
  pagination: {
    pageNumber: 1,
    pageSize: 20,
  },
  reducers: [],
};
